"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWithInMemoryCache;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var memoryCache = {};
var pendingRequests = {};

function getWithInMemoryCache(_x, _x2) {
  return _getWithInMemoryCache.apply(this, arguments);
}

function _getWithInMemoryCache() {
  _getWithInMemoryCache = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url, queryParams) {
    var cacheKey;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cacheKey = url + JSON.stringify(queryParams);

            if (!memoryCache[cacheKey]) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", memoryCache[cacheKey]);

          case 3:
            if (!pendingRequests[cacheKey]) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", pendingRequests[cacheKey]);

          case 5:
            pendingRequests[cacheKey] = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
              var response;
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return _axios.default.get(url, {
                        params: queryParams
                      });

                    case 3:
                      response = _context.sent;
                      memoryCache[cacheKey] = response.data;
                      return _context.abrupt("return", response.data);

                    case 8:
                      _context.prev = 8;
                      _context.t0 = _context["catch"](0);
                      delete pendingRequests[cacheKey];
                      console.error(_context.t0);

                    case 12:
                      _context.prev = 12;
                      delete pendingRequests[cacheKey];
                      return _context.finish(12);

                    case 15:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 8, 12, 15]]);
            }))();
            return _context2.abrupt("return", pendingRequests[cacheKey]);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getWithInMemoryCache.apply(this, arguments);
}

getWithInMemoryCache.clearCache = function () {
  memoryCache = {};
  pendingRequests = {};
};